export const REDUCER_INDEX = 'divisions';
